import React from 'react'
import styled from 'styled-components'

const StyledHotLeadValidationScreen = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  box-shadow: 0 0 12px 0 var(--black-20);
  background-color: #f5f7fa;
  flex-direction: column;
  padding: 1.5rem;

  h3 {
    font-weight: normal;
    font-size: 1.125rem;
    padding: 0;
    margin: 0;
  }

  p {
    font-size: 1.125rem;
    margin: 0.75rem 0;
  }
`
const HotLeadValidationScreen = () => {
  const content = (
    <>
      <StyledHotLeadValidationScreen>
        <div style={{ width: '100%' }}>
          <h3>
            Merci, <b> votre demande d&apos;estimation a bien été envoyée. </b>
            <br />
            Un conseiller vous contactera au plus vite.
          </h3>
        </div>
      </StyledHotLeadValidationScreen>
    </>
  )
  return content
}

export default HotLeadValidationScreen
